export default function (id: any | number) {
  return id?.id || id
}
